import "./Plugins/ServiceWorkerRegistration.js";
import "./Plugins/InstallPromptCapture.js";
import "./bootstrap";
import Plugins from "./Plugins/index.js";
import Router from "./Routes/router";
import {createApp} from "vue";
import {ZiggyVue} from "ziggy-js";
import App from "@/App.vue";

console.log(import.meta.env.VITE_APP_VERSION);
const appName = import.meta.env.VITE_APP_NAME || "ASKr";

createApp(App).use(ZiggyVue).use(Router).use(Plugins).mount("#app");
